<template>
  <div :class="['product-details-vehicle', { 'product-details-vehicle--selected': modelSelected, 'element--is-loading': fitsForLoading }]">
    <h2 class="body-semi-bold">
      {{ modelSelected ? tStatic('selectedProductFitsVehicle') : tStatic('checkProductFitsVehicle') }}
    </h2>

    <oie-vehicle-selector-slide-in
      name="product-details-vehicle-selection"
      :source="() => useProductRelatedNodeData(model)"
      :force-model-selection="true"
      @confirm="handleSelection"
      @initialized="handleInitialized"></oie-vehicle-selector-slide-in>
  </div>
</template>

<script>
import useProductRelatedNodeData from '@/composables/useProductRelatedNodeData'
import { defineComponent, ref, onBeforeUnmount } from '@vue/composition-api'
import EventBus from '@/core/event-bus'

export default defineComponent({
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup() {
    const modelSelected = ref(false)
    // Initialise from the flag set by fits-for-lazy so we catch the case where
    // fitsfor.loading fired before this component was mounted
    const fitsForLoading = ref(EventBus.fitsForLoading === true)

    function handleSelection(node) {
      window.location = node.url
    }

    function handleInitialized(deepestNodeSelection) {
      if (deepestNodeSelection.isModel) {
        modelSelected.value = true
      }
    }

    const onFitsForLoading = () => { fitsForLoading.value = true }
    const onFitsForLoaded = () => { fitsForLoading.value = false }

    EventBus.$on('fitsfor.loading', onFitsForLoading)
    EventBus.$on('fitsfor.loaded', onFitsForLoaded)

    onBeforeUnmount(() => {
      EventBus.$off('fitsfor.loading', onFitsForLoading)
      EventBus.$off('fitsfor.loaded', onFitsForLoaded)
    })

    return {
      modelSelected,
      fitsForLoading,
      handleSelection,
      handleInitialized,
      useProductRelatedNodeData
    }
  }
})
</script>

<style lang="scss">
.product-details-vehicle {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: measure(half);
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
  padding: measure(quarter) measure(half);

  @include media(medium) {
    padding: measure(half) measure(full);
  }
}

.product-details-vehicle--selected {
  background-color: color(background-light-green);
  border: 1px solid color(border-green-3);
}
</style>
